export const driverKeys = {
  all: ['driver'] as const,
  realtrip: () => [...driverKeys.all, 'realtrip'] as const,
  realtripDetail: (id: number) => [...driverKeys.realtrip(), id] as const,
  realtrips: () => [...driverKeys.all, 'realtrips'] as const,
  tripStops: (realtripId: number) => [...driverKeys.all, 'tripStops', realtripId] as const,
  bustickets: (realtripId: number) => [...driverKeys.all, 'bustickets', realtripId] as const,
  subscribers: (realtripId: number) => [...driverKeys.all, 'subscribers', realtripId] as const,
  availability: (realtripId: number) => [...driverKeys.all, 'availability', realtripId] as const,
};
